import { render, staticRenderFns } from "./appointCancel.vue?vue&type=template&id=3584506e&scoped=true"
import script from "./appointCancel.vue?vue&type=script&lang=js"
export * from "./appointCancel.vue?vue&type=script&lang=js"
import style0 from "./appointCancel.vue?vue&type=style&index=0&id=3584506e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3584506e",
  null
  
)

export default component.exports